import {
  AnnouncementsHomeActions,
  changeFiltersAnnouncementsHomeType,
  researchAnnouncementsHomeType,
} from "../../actions/announcements/home";

export interface AnnouncementsHomeStore {
  filters: App.Announcement.FiltersForSearch;
  research: number;
}

class AnnouncementsHomeReducer {
  public get defaultStore(): AnnouncementsHomeStore {
    return {
      filters: {
        car: [{ brand: null, model: null }],
        other: [],
      },
      research: 0,
    };
  }
  public store(
    store: AnnouncementsHomeStore,
    action: AnnouncementsHomeActions
  ) {
    switch (action.type) {
      case changeFiltersAnnouncementsHomeType:
        store.filters = action.filters;
        break;
      case researchAnnouncementsHomeType:
        store.research = +new Date();
        break;

      default:
        break;
    }
    return store;
  }
}

export default new AnnouncementsHomeReducer();
